module.exports = __webpack_public_path__ + "static/assets/bf99fbafe9a01e45da63a6874cd8f4b2.mp3";